import React, { useContext } from "react";
import { ColorContext } from "..";
import styled from "styled-components";

const StyledDiv = styled.div`
    display:grid;
    grid-template-columns: repeat(12,1fr);
    height: 80vh;
`;

const Heading = styled.h2`
    color: ${props => props.color};
    overflow: hidden;
    text-align: left;
    grid-column: 2 / 12;
    margin: 0; 
    padding: 10rem 2rem 4rem 1.5rem;
    font-size: 4rem;

    @media (min-width: 576px) {
        grid-column: 2 / 9;
        font-size: 5rem;
    }

    @media (min-width: 768px) {
        grid-column: 2 / 11;
        font-size: 8rem;
    }

    @media (min-width: 1200px) {
        grid-column: 2 / 8;
    }

    @media (max-height: 500px) {
        padding: 2rem 1rem;
    }
`;

function Content() {
    const colors = useContext(ColorContext);
    return (
        <StyledDiv>
            <Heading color={colors}>&lt;Under Development/&gt;</Heading>
        </StyledDiv>)
}

export default Content;